// removed by extract-text-webpack-plugin
module.exports = {"SearchResults":"genericSearchResults__SearchResults__1OdKc","SearchResItem":"genericSearchResults__SearchResItem__34qYu","Label":"genericSearchResults__Label__3oPpM","AltLabel":"genericSearchResults__AltLabel__27axs","FlexRow":"genericSearchResults__FlexRow__x26Fc"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Search/genericSearchResults.css
// module id = 942
// module chunks = 2